export const COUNTRIES_ARRAY = [
  ["Polska", "PL"],
  ["Niemcy", "DE"],
  ["Belgia", "BE"],
  ["Holandia", "NL"],
  ["Francja", "FR"],
  ["Litwa", "LT"],
  ["Łotwa", "LV"],
  ["Norway", "NO"],
  ["Czechia", "CZ"],
  ["Szwecja", "SE"],
  ["Łotwa", "LV"],
]

export const PL_PROVINCES_ARRAY = [
  [
    "Dolnośląskie",
    "DO",
    [
      ["Wrocław", "wroclaw"],
      ["Wałbrzych", "walbrzych"],
      ["Legnica", "legnica"],
      ["Jelenia Góra", "jeleniagora"],
      ["Lubin", "lubin"],
      ["Głogów", "glogow"],
      ["Świdnica", "swidnica"],
      ["Bolesławiec", "boleslawiec"],
      ["Oleśnica", "olesnica"],
      ["Dzierżoniów", "dzierzoniow"],
    ],
  ],
  [
    "Kujawsko-pomorskie",
    "KP",
    [
      ["Bydgoszcz", "bydgoszcz"],
      ["Toruń", "torun"],
      ["Włocławek", "wloclawek"],
      ["Grudziądz", "grudziadz"],
      ["Inowrocław", "inowroclaw"],
      ["Brodnica", "brodnica"],
      ["Świecie", "swiecie"],
      ["Chełmno", "chelmno"],
      ["Nakło nad Notecią", "naklonadnotecia"],
      ["Rypin", "rypin"],
    ],
  ],
  [
    "Lubelskie",
    "LU",
    [
      ["Lublin", "lublin"],
      ["Chełm", "chelm"],
      ["Zamość", "zamosc"],
      ["Biała Podlaska", "bialapodlaska"],
      ["Puławy", "pulawy"],
      ["Świdnik", "swidnik"],
      ["Kraśnik", "krasnik"],
      ["Łuków", "lukow"],
      ["Biłgoraj", "bilgoraj"],
      ["Lubartów", "lubartow"],
    ],
  ],
  [
    "Lubuskie",
    "LE",
    [
      ["Zielona Góra", "zielonagora"],
      ["Gorzów Wielkopolski", "gorzowwielkopolski"],
      ["Nowa Sól", "nowasol"],
      ["Żary", "zary"],
      ["Żagań", "zagan"],
      ["Świebodzin", "swiebodzin"],
      ["Międzyrzecz", "miedzyrzecz"],
      ["Sulechów", "sulechow"],
      ["Słubice", "slubice"],
    ],
  ],
  [
    "Łódzkie",
    "LO",
    [
      ["Łódź", "lodz"],
      ["Piotrków Trybunalski", "piotrkowtrybunalski"],
      ["Pabianice", "pabianice"],
      ["Tomaszów Mazowiecki", "tomaszowmazowiecki"],
      ["Bełchatów", "belchatow"],
      ["Zgierz", "zgierz"],
      ["Skierniewice", "skierniewice"],
      ["Radomsko", "radomsko"],
      ["Kutno", "kutno"],
      ["Zduńska Wola", "zdunskawola"],
    ],
  ],
  [
    "Małopolskie",
    "MA",
    [
      ["Kraków", "krakow"],
      ["Tarnów", "tarnow"],
      ["Nowy Sącz", "nowysacz"],
      ["Oświęcim", "oswiecim"],
      ["Chrzanów", "chrzanow"],
      ["Olkusz", "olkusz"],
      ["Nowy Targ", "nowytarg"],
      ["Bochnia", "bochnia"],
      ["Gorlice", "gorlice"],
      ["Zakopane", "zakopane"],
    ],
  ],
  [
    "Mazowieckie",
    "MZ",
    [
      ["Warszawa", "warszawa"],
      ["Radom", "radom"],
      ["Płock", "plock"],
      ["Siedlce", "siedlce"],
      ["Pruszków", "pruszkow"],
      ["Ostrołęka", "ostroleka"],
      ["Legionowo", "legionowo"],
      ["Ciechanów", "ciechanow"],
      ["Otwock", "otwock"],
      ["Żyrardów", "zyrardow"],
    ],
  ],
  [
    "Opolskie",
    "OP",
    [
      ["Opole", "opole"],
      ["Kędzierzyn-Koźle", "kedzierzynkozle"],
      ["Nysa", "nysa"],
      ["Brzeg", "brzeg"],
      ["Kluczbork", "kluczbork"],
      ["Prudnik", "prudnik"],
      ["Strzelce Opolskie", "strzelceopolskie"],
      ["Krapkowice", "krapkowice"],
      ["Namysłów", "namyslow"],
      ["Głuchołazy", "glucholazy"],
    ],
  ],
  [
    "Podkarpackie",
    "PD",
    [
      ["Rzeszów", "rzeszow"],
      ["Przemyśl", "przemysl"],
      ["Stalowa Wola", "stalowawola"],
      ["Mielec", "mielec"],
      ["Tarnobrzeg", "tarnobrzeg"],
      ["Krosno", "krosno"],
      ["Dębica", "debica"],
      ["Jarosław", "jaroslaw"],
      ["Sanok", "sanok"],
      ["Jasło", "jaslo"],
    ],
  ],
  [
    "Podlaskie",
    "PE",
    [
      ["Białystok", "bialystok"],
      ["Suwałki", "suwalki"],
      ["Łomża", "lomza"],
      ["Augustów", "augustow"],
      ["Bielsk Podlaski", "bielskpodlaski"],
      ["Zambrów", "zambrow"],
      ["Grajewo", "grajewo"],
      ["Hajnówka", "hajnowka"],
      ["Sokółka", "sokolka"],
      ["Łapy", "lapy"],
    ],
  ],
  [
    "Pomorskie",
    "PO",
    [
      ["Gdańsk", "gdansk"],
      ["Gdynia", "gdynia"],
      ["Słupsk", "slupsk"],
      ["Tczew", "tczew"],
      ["Starogard Gdański", "starogardgdanski"],
      ["Wejherowo", "wejherowo"],
      ["Rumia", "rumia"],
      ["Chojnice", "chojnice"],
      ["Sopot", "sopot"],
      ["Malbork", "malbork"],
    ],
  ],
  [
    "Śląskie",
    "SL",
    [
      ["Katowice", "katowice"],
      ["Częstochowa", "czestochowa"],
      ["Sosnowiec", "Sosnowiec"],
      ["Gliwice", "gliwice"],
      ["Zabrze", "zabrze"],
      ["Bytom", "bytom"],
      ["Bielsko-Biała", "bielskobiala"],
      ["Ruda Śląska", "rudaslaska"],
      ["Rybnik", "rybnik"],
      ["Tychy", "tychy"],
    ],
  ],
  [
    "Świętokrzyskie",
    "SW",
    [
      ["Kielce", "kielce"],
      ["Ostrowiec Świętokrzyski", "ostrowiecswietokrzyski"],
      ["Starachowice", "starachowice"],
      ["Skarżysko-Kamienna", "skarzyskokamienna"],
      ["Sandomierz", "sandomierz"],
      ["Końskie", "konskie"],
      ["Busko-Zdrój", "buskozdroj"],
      ["Jędrzejów", "jedrzejow"],
      ["Staszów", "staszow"],
      ["Pińczów", "pinczow"],
    ],
  ],
  [
    "Warmińsko-mazurskie",
    "WM",
    [
      ["Olsztyn", "olsztyn"],
      ["Elbląg", "elblag"],
      ["Ełk", "elk"],
      ["Ostróda", "ostroda"],
      ["Iława", "ilawa"],
      ["Giżycko", "gizycko"],
      ["Kętrzyn", "ketrzyn"],
      ["Szczytno", "szczytno"],
      ["Bartoszyce", "bartoszyce"],
      ["Mrągowo", "mragowo"],
    ],
  ],
  [
    "Wielkopolskie",
    "WE",
    [
      ["Poznań", "poznan"],
      ["Kalisz", "kalisz"],
      ["Konin", "konin"],
      ["Piła", "pila"],
      ["Ostrów Wielkopolski", "ostrowwielkopolski"],
      ["Gniezno", "gniezno"],
      ["Leszno", "leszno"],
      ["Swarzędz", "swarzedz"],
      ["Śrem", "srem"],
      ["Krotoszyn", "krotoszyn"],
    ],
  ],
  [
    "Zachodniopomorskie",
    "ZP",
    [
      ["Szczecin", "szczecin"],
      ["Koszalin", "koszalin"],
      ["Stargard", "stargard"],
      ["Kołobrzeg", "kolobrzeg"],
      ["Świnoujście", "swinoujscie"],
      ["Szczecinek", "szczecinek"],
      ["Police", "police"],
      ["Wałcz", "walcz"],
      ["Białogard", "bialogard"],
      ["Goleniów", "goleniow"],
    ],
  ],
]

export const DE_PROVINCES_ARRAY = [
  ["Baden-Württemberg", "BW"],
  ["Bayern", "BY"],
  ["Berlin", "BE"],
  ["Brandenburg", "BB"],
  ["Bremen", "HB"],
  ["Niedersachsen", "NDS"],
  ["Hamburg", "HH"],
  ["Hessen", "HE"],
  ["Mecklenburg-Vorpommern", "MV"],
  ["Nordrhein-Westfalen", "NRW"],
  ["Rheinland-Pfalz", "RP"],
  ["Saarland", "SL"],
  ["Sachsen", "SN"],
  ["Sachsen-Anhalt", "SA"],
  ["Schleswig-Holstein", "SH"],
  ["Thüringen", "TH"],
]

export const BE_PROVINCES_ARRAY = [
  ["Région Wallonne", "RW"],
  ["Vlaams Gewest", "VG"],
  ["Brussel", "BR"],
]

export const NL_PROVINCES_ARRAY = [
  ["Drenthe", "DR"],
  ["Flevoland", "FL"],
  ["Fryslân", "FR"],
  ["Gelderland", "GE"],
  ["Groningen", "GR"],
  ["Limburg", "LI"],
  ["Noord-Brabant", "NB"],
  ["Noord-Holland", "NH"],
  ["Utrecht", "UT"],
  ["Overijssel", "OV"],
  ["Zeeland", "ZE"],
  ["Zuid-Holland", "ZH"],
]

export const FR_PROVINCES_ARRAY = [
  ["Bretagne", "BR"],
  ["Bourgogne-Franche-Comté", "BF"],
  ["Grand Est", "GE"],
  ["Hauts-de-France", "HF"],
  ["Île-de-France", "IF"],
  ["Corse", "CO"],
  ["Pays de la Loire", "PL"],
  ["Normandie", "NO"],
  ["Nouvelle-Aquitaine", "NA"],
  ["Occitanie", "OC"],
  ["Auvergne-Rhône-Alpes", "AR"],
  ["Provence-Alpes-Côte d’Azur", "PA"],
  ["Centre-Val de Loire", "CL"],
]

export const LT_PROVINCES_ARRAY = [
  ["Vilniaus apskritis", "VI"],
  ["Kauno apskritis", "KA"],
  ["Klaipėdos apskritis", "KL"],
  ["Šiaulių apskritis", "SI"],
  ["Panevėžio apskritis", "PA"],
  ["Alytaus apskritis", "AL"],
  ["Marijampolės apskritis", "MA"],
  ["Tauragės apskritis", "TA"],
  ["Telšių apskritis", "TE"],
  ["Utenos apskritis", "UT"],
]

export const NO_PROVINCES_ARRAY = [
  ["Oslo", "OS"],
  ["Innlandet", "IN"],
  ["Telemark", "TE"],
  ["Agder", "AG"],
  ["Rogaland", "RO"],
  ["Vestland", "VE"],
  ["Møre og Romsdal", "MR"],
  ["Trøndelag", "TR"],
  ["Nordland", "NO"],
  ["Troms", "TS"],
  ["Vestfold", "VF"],
  ["Østfold", "OF"],
  ["Akershus", "AK"],
  ["Buskerud", "BU"],
  ["Finnmark", "FI"],
]

export const CZ_PROVINCES_ARRAY = [
  ["Hlavní město Praha", "PR"],
  ["Středočeský kraj", "CB"],
  ["Jihočeský kraj", "SB"],
  ["Plzeňský kraj", "PL"],
  ["Karlovarský kraj", "KV"],
  ["Ústecký kraj", "US"],
  ["Liberecký kraj", "LI"],
  ["Královéhradecký kraj", "HR"],
  ["Pardubický kraj", "PA"],
  ["Kraj Vysočina", "VY"],
  ["Jihomoravský kraj", "SM"],
  ["Olomoucký kraj", "OL"],
  ["Zlínský kraj", "ZL"],
  ["Moravskoslezský kraj", "MO"],
]

export const LOCALIZATION_ARRAY = [
  ["Polska", "PL", PL_PROVINCES_ARRAY],
  ["Niemcy", "DE", DE_PROVINCES_ARRAY],
  ["Belgia", "BE", BE_PROVINCES_ARRAY],
  ["Holandia", "NL", NL_PROVINCES_ARRAY],
  ["Francja", "FR", FR_PROVINCES_ARRAY],
  ["Litwa", "LT", LT_PROVINCES_ARRAY],
  ["Norwegia", "NO", NO_PROVINCES_ARRAY],
  ["Czechy", "CZ", CZ_PROVINCES_ARRAY],
]
